import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {SelectItem} from 'primeng/api';
import {AcabimSite, GenericPayloadModel, GenericPayloadType, SiteApiService} from '@cas-hub/acabim-common-client';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'acabim-admin-assign-site-groups',
  templateUrl: './assign-site-groups.component.html',
  styleUrls: ['../styles.scss', './assign-site-groups.component.scss']
})
export class AssignSiteGroupsComponent implements OnInit {

  @Input() set siteDetails(value: any[]) {
    console.dir(value);
    this.sites = [];
    if (value) {
      this.sitesFull = value;
      value.map(site => {
        console.dir(site);
        if(site.name) {
          this.sites.push({key: site.id, label: 'Value 1', value: site.name, type: GenericPayloadType.text},)
        }
      })
    }
  }
  @Output() completed: EventEmitter<boolean> = new EventEmitter();
  groups: SelectItem[] = [];
  groupForm: FormGroup = new FormGroup({
    selectedGroups: new FormControl()
  });
  isLoading = false;
  isDone = false;
  sites: GenericPayloadModel[] = [];
  sitesFull: AcabimSite[] = [];
  selectedGroups: string[] = [];

  constructor(
      private readonly siteApiService: SiteApiService
  ) { }

  ngOnInit(): void {
    this.siteApiService.getAllSiteGroups().subscribe(data => {
      console.dir(data);
      if(data && data.data) {
        data.data.map(d => {
          this.groups.push({label: d.name, value: d.id});
        });
      }
    });
  }

  onSubmit(): void {
    this.gather();
  }

  onDone() {
    this.isDone = false;
    this.completed.emit(true);
  }

  gather(): void {
    if (this.groupForm && this.sites.length > 0) {
      this.selectedGroups = this.groupForm.get('selectedGroups')?.value;
      if (this.selectedGroups.length > 0) {
        let counter = 0;
        this.isLoading = true;
        this.sitesFull.forEach(site => {
            this.siteApiService.setSiteGroups(site.id, this.selectedGroups).subscribe(result => {
              counter++;
              if(counter === this.selectedGroups.length) {
                this.isLoading = false;
                this.isDone = true;
              }
              console.dir(result);
            });
        });
      }
    }
  }

} // end of class
